<pa-checkbox
    [selected]="control.value"
    (isSelectedChange)="setValue($event)">{{ schema.title }}</pa-checkbox>
